define('components/textarea-grow',['jquery', 'core/can'], function($, can) {
	
	can.view.attr('textarea-grow', function(el, attrData) {
		
		var ruler = $('<div class="ruler">');
		
		el = $(el);
		
		el.after(ruler);

		el.on('keyup', function () {
		    ruler.html(el.val().replace(/\n/g, '<br>') + '<br>');
		    el.css('height', ruler.height() + 20);
		});

	});

});
